import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=c5e1d30a&"
import script from "./forget.vue?vue&type=script&lang=js&"
export * from "./forget.vue?vue&type=script&lang=js&"
import style0 from "./forget.vue?vue&type=style&index=0&id=c5e1d30a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports